export default (() => {
    
    const Array = () => new wealthify.PropType('Array', {
        validator: wealthify.propValidators.IsTypeArray(),
        formatter: wealthify.type.array.toArray,
        isComplex: true
    });
    
    const ArrayItem = (array) => new wealthify.PropType('ArrayItem', {validator: wealthify.propValidators.IsInArray(array)});
    
    const Boolean = () => new wealthify.PropType('Boolean', {
        validator: wealthify.propValidators.IsTypeBoolean(),
        formatter: wealthify.type.boolean.toBoolean
    });

    const Function = () => new wealthify.PropType('Function', {
        validator: wealthify.propValidators.IsTypeFunction(),
        formatter: wealthify.type.function.toFunction,
        isComplex: true
    });

    const FunctionReference = () => new wealthify.PropType('FunctionReference', {
        validator: wealthify.propValidators.IsTypeFunction(),
        formatter: wealthify.type.function.toFunctionFromReference,
        isComplex: true
    });

    const Number = () => new wealthify.PropType('Number', {
        validator: wealthify.propValidators.IsTypeNumber(),
        formatter: wealthify.type.number.toNumber
    });

    const Object = () => new wealthify.PropType('Object', {
        validator: wealthify.propValidators.IsTypeObject(),
        formatter: wealthify.type.object.toObject,
        isComplex: true
    });

    const Regex = () => new wealthify.PropType('Regex', {
        validator: wealthify.propValidators.IsTypeRegex(),
        formatter: wealthify.regex.toInputFriendlyString
    });

    const UniqueArray = () => new wealthify.PropType('UniqueArray', {
        validator: wealthify.propValidators.IsTypeUniqueArray(),
        formatter: wealthify.type.array.toArray,
        isComplex: true
    });

    return {
        Array,
        ArrayItem,
        Boolean,
        Function,
        FunctionReference,
        Number,
        Object,
        Regex,
        UniqueArray
    };

})();
